import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'

export type BreadcrumbsItemsState = {
  yearlySummary?: string | null
  projects?: string | null
  users?: string | null
  worklog?: string | null
  schedule?: string | null
  demands?: string | null
  candidates?: string | null
  adminSettings?: string | null
  vacations?: string | null
  reports?: string | null
  projectsDistribution?: string | null
  settlements?: string | null
  costSummary?: string | null
  myProfile?: string | null
  leaderView?: string | null
}

const initialState: BreadcrumbsItemsState = {
  yearlySummary: null,
  projects: null,
  users: null,
  worklog: null,
  schedule: null,
  demands: null,
  candidates: null,
  adminSettings: null,
  vacations: null,
  reports: null,
  projectsDistribution: null,
  settlements: null,
  costSummary: null,
  myProfile: null,
  leaderView: null
}

export const pageHeaderSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    setInitialState: () => {
      return initialState
    },
    setSelectedItems: (state, action: PayloadAction<BreadcrumbsItemsState>) => {
      return {
        projects: action.payload.projects,
        users: action.payload.users,
        worklog: action.payload.worklog,
        schedule: action.payload.schedule,
        yearlySummary: action.payload.yearlySummary,
        demands: action.payload.demands,
        candidates: action.payload.candidates,
        adminSettings: action.payload.adminSettings,
        vacations: action.payload.vacations,
        reports: action.payload.reports,
        projectsDistribution: action.payload.projectsDistribution,
        settlements: action.payload.settlements,
        costSummary: action.payload.costSummary,
        myProfile: action.payload.myProfile,
        leaderView: action.payload.leaderView
      }
    },
  },
})

export const getBreadcrumbsItemsState = (state: RootState) => state.breadcrumbs

export const breadcrumbsItemsActions = pageHeaderSlice.actions
export const breadcrumbsItemsReducer = pageHeaderSlice.reducer

export default breadcrumbsItemsReducer
